import {MatxLoadable} from "matx";

const Layout1 = MatxLoadable({
  loader: () => import("./ZipcarLayout/ZipcarLayoutIndex")
});

export const MatxLayouts = {
  layout1: Layout1
}